import type {UvMapNode} from "#material/cycles/types"
import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {UvMapSockets} from "#material/nodes/input/uv-map/definition"
import {uvMapDefinition} from "#material/nodes/input/uv-map/definition"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import {registerMaterialGraphNode} from "#material/register"
import {ThreeTsl as TSL} from "#material/three/exports"
import type {ThreeReturns} from "#material/sockets/three"
import type {CyclesReturns} from "#material/sockets/cycles"

@registerMaterialGraphNode
export class UvMap extends MaterialNode<UvMapSockets> {
    public override get definition() {
        return uvMapDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<UvMapSockets>> => {
        const index = this.parameters.settings.uvMapIndex ?? 0
        const uv = TSL.uv(index)
        return {uv: TSL.vec3(uv, 0)}
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<UvMapSockets>> => {
        const uvMap: UvMapNode = {
            type: "uvmap",
            inputs: {},
            parameters: {attribute: `UVMap${this.parameters.settings.uvMapIndex ?? 0}`, from_dupli: false},
            resources: {},
        }

        return {uv: [uvMap, "uv"]}
    }
}
